import type { ReactNode } from "react";
import { cn } from "@/shared/lib/cn";

/** A hairline keycap for shortcut hints (search row, palette footer). */
export interface KbdProps {
  children: ReactNode;
  className?: string;
}

export function Kbd({ children, className }: KbdProps) {
  return (
    <kbd
      className={cn(
        "inline-grid h-[18px] min-w-[18px] place-items-center rounded-[6px] bg-line-soft px-1 font-sans text-[11px] font-medium text-ink-faint",
        className,
      )}
    >
      {children}
    </kbd>
  );
}
